"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var UsePromocode = function (_a) {
    var onClose = _a.onClose, onCancel = _a.onCancel, bonus = _a.bonus;
    var t = (0, next_intl_1.useTranslations)('translation');
    return (react_1.default.createElement(ui_components_1.Modal, { className: styles_module_scss_1.default.modal, width: "480px", height: "auto", portalNodeId: "modal", onClose: onClose, saveSize: true },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.bonus },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.bonusBonus }, bonus === null || bonus === void 0 ? void 0 : bonus.title)),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.buttonWrapper },
                react_1.default.createElement(ui_components_1.FixedButton, { color: "primary", onClick: onClose }, t('useBonus')),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.cancelBonus, onClick: onCancel }, t('useAnotherBonus'))))));
};
exports.default = UsePromocode;
